import  React from "react"
import {Helmet} from "react-helmet"

const Seo = (props) => {
  let canonical = props.canonical
  if (canonical === "https://www.journaldemontreal.com/2025/06/23/lancien-militant-dextreme-gauche-maurizio-di-marzio-libere-sous-controle-judiciaire" ){
    canonical = "https://www.journaldemontreal.com/monde/europe/lancien-militant-dextreme-gauche-maurizio-di-marzio-libere-sous-controle-judiciaire"
  }
  return(
    <Helmet>
      <title>{props.title}</title>
      <meta name="description" content={props.lead}/>
      <meta name="author" content=""/>

      <meta property="og:title" content={props.title} />
      <meta property="og:type"   content="article" />
      <meta property="og:description" content={props.lead} />
      <link rel="canonical" href={canonical} />

    </Helmet>
  )
}

export default Seo